import { Controller } from "stimulus"
import DateInput from "../../lib/date_input"

const CHEVRON_LEFT = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>'
const CHEVRON_RIGHT = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>'

export default class extends Controller {
  static targets = ["container", "input", "button"]
  static values = { position: String }

  connect() {
    new DateInput({
      container: this.containerTarget,
      input: this.inputTarget,
      toggleButton: this.buttonTarget,
      nextButtonHTML: CHEVRON_RIGHT,
      previousButtonHTML: CHEVRON_LEFT,
      position: this.positionValue || "below",
    })
  }
}
